import httpClient from '../utils/httpClient';
import { API_ENDPOINTS } from '../config/api';

export const paymentService = {
  // Create Razorpay order
  async createOrder(amount, currency = 'INR', userInfo = {}, metaEventId = null, addPaymentMetaEventId = null) {
    const response = await httpClient.post(API_ENDPOINTS.PAYMENT.CREATE_ORDER, {
      amount, // In paise
      currency,
      notes: JSON.stringify(userInfo),
      metaEventId,
      addPaymentMetaEventId,
      email: userInfo.email,
      phone: userInfo.phone
    });
    return response;
  },

  // Verify payment after Razorpay callback
  async verifyPayment(paymentData) {
    const response = await httpClient.post(API_ENDPOINTS.PAYMENT.VERIFY, {
      razorpayOrderId: paymentData.razorpayOrderId,
      razorpayPaymentId: paymentData.razorpayPaymentId,
      razorpaySignature: paymentData.razorpaySignature,
      name: paymentData.name,
      email: paymentData.email,
      phone: paymentData.phone,
      dateOfBirth: paymentData.dateOfBirth,
      timeOfBirth: paymentData.timeOfBirth,
      placeOfBirth: paymentData.placeOfBirth,
      message: paymentData.message,
      consultationDate: paymentData.consultationDate,
      consultationTimeSlot: paymentData.consultationTimeSlot
    });
    return response;
  },

  // Open Razorpay checkout modal
  openRazorpay(options) {
    if (!window.Razorpay) {
      throw new Error('Razorpay SDK not loaded. Please refresh the page and try again.');
    }

    const razorpay = new window.Razorpay(options);
    razorpay.open();

    return razorpay;
  }
};

export default paymentService;
